import { render, staticRenderFns } from "./LabeledSelect.vue?vue&type=template&id=70b1c577&scoped=true&"
import script from "./LabeledSelect.vue?vue&type=script&lang=js&"
export * from "./LabeledSelect.vue?vue&type=script&lang=js&"
import style0 from "./LabeledSelect.vue?vue&type=style&index=0&id=70b1c577&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b1c577",
  null
  
)

export default component.exports